import {createAction, props} from '@ngrx/store';
import {Update} from '@ngrx/entity';

import {CitizensServices, filterByLocation, filteringInputCitizenServices} from './citizens-services.model';

export const loadCitizensServicess = createAction(
  '[CitizensServices/API] Load CitizensServicess',
  props<{ citizensServicess: CitizensServices[] }>()
);

export const addCitizensServices = createAction(
  '[CitizensServices/API] Add CitizensServices',
  props<{ citizensServices: CitizensServices }>()
);

export const upsertCitizensServices = createAction(
  '[CitizensServices/API] Upsert CitizensServices',
  props<{ citizensServices: CitizensServices }>()
);

export const addCitizensServicess = createAction(
  '[CitizensServices/API] Add CitizensServicess',
  props<{ citizensServicess: CitizensServices[] }>()
);

export const upsertCitizensServicess = createAction(
  '[CitizensServices/API] Upsert CitizensServicess',
  props<{ citizensServicess: CitizensServices[] }>()
);

export const updateCitizensServices = createAction(
  '[CitizensServices/API] Update CitizensServices',
  props<{ citizensServices: Update<CitizensServices> }>()
);

export const updateCitizensServicess = createAction(
  '[CitizensServices/API] Update CitizensServicess',
  props<{ citizensServicess: Update<CitizensServices>[] }>()
);

export const deleteCitizensServices = createAction(
  '[CitizensServices/API] Delete CitizensServices',
  props<{ id: string }>()
);

export const deleteCitizensServicess = createAction(
  '[CitizensServices/API] Delete CitizensServicess',
  props<{ ids: string[] }>()
);

export const clearCitizensServicess = createAction(
  '[CitizensServices/API] Clear CitizensServicess'
);


//CUSTOM


export const citizenGetServices = createAction(
  '[CitizensServices/API] citizen Get Services',
  props<{ filtering: filteringInputCitizenServices, showFew?: boolean }>()
);

export const getCitizenRequestedServices = createAction(
  '[CitizensServices/API] getCitizenRequestedServices'
);

export const citizenGetAllServicesByLocation = createAction(
  '[CitizensServices/API] citizen Get All Services By Location',
  props<{ filtering: filterByLocation }>()
);


export const citizenGetServicesFromSector = createAction(
  '[CitizensSector/API] citizen Get Services FromSector',
  props<{ sectorUniqueId: string, pageNumber: number, itemsPerPage: number, showFew?: boolean }>()
);


export const citizenGetServicesFromSocialGroup = createAction(
  '[CitizensSector/API] citizen Get Services From Social Group',
  props<{
    filtering: {
      socialGroup: string[],
      pageNumber: number,
      itemsPerPage: number
    }
  }>()
);
